import React from "react";
import {
  FaDesktop,
  FaHeadset,
  FaShieldAlt,
  FaShoppingCart,
  FaStore,
  FaTachometerAlt
} from "react-icons/fa";
import SEO from "../components/SEO";
import GameShowcasePage from "../components/GameShowcasePage";

const storyParagraphs = [
  "WarFront non deve partire dal pulsante Compra. Prima devi sapere che gioco è, cosa serve per installarlo e cosa succede dopo il pagamento.",
  "L'acquisto passa dallo Store Kyros. La licenza resta collegata al tuo account e il download viene gestito dal launcher Windows.",
  "Se qualcosa non torna, la pagina supporto resta a portata di mano: requisiti, licenza e richiesta di rimborso devono essere chiari prima del checkout."
];

const features = [
  {
    title: "FPS tattico per PC",
    description:
      "WarFront è pensato per Windows e viene installato dal launcher Kyros.",
    icon: FaTachometerAlt
  },
  {
    title: "Acquisto collegato all'account",
    description:
      "Accedi, compra dallo Store e ritrovi la licenza nella libreria Kyros.",
    icon: FaShieldAlt
  },
  {
    title: "Supporto prima e dopo",
    description:
      "Prima di pagare puoi leggere requisiti, termini e canale per assistenza o rimborso.",
    icon: FaHeadset
  }
];

const facts = [
  { label: "Stato", value: "Scheda prodotto pronta" },
  { label: "Piattaforma", value: "Windows" },
  { label: "Acquisto", value: "Store Kyros con account" },
  { label: "Installazione", value: "Launcher Kyros" }
];

const mediaCard = (
  <section className="game-showcase__media-card">
    <p className="game-showcase__section-kicker">Prima di comprare</p>
    <h2>Cosa controllare</h2>
    <div className="game-showcase__media-frame game-showcase__media-frame--image">
      <img src="/images/warfront_background.jpg" alt="Scenario promozionale di WarFront" />
    </div>
    <ul className="game-showcase__requirements">
      <li>
        <FaDesktop aria-hidden="true" />
        <span>PC Windows</span>
      </li>
      <li>
        <FaStore aria-hidden="true" />
        <span>Account Kyros per Store e libreria</span>
      </li>
      <li>
        <FaHeadset aria-hidden="true" />
        <span>Supporto acquisto dalla pagina termini</span>
      </li>
    </ul>
  </section>
);

export default function WarFrontPage() {
  return (
    <>
      <SEO
        title="WarFront | Kyros Games"
        description="WarFront: scheda prodotto, requisiti, licenza account e Store Kyros prima dell'acquisto."
        canonical="https://kyrosgames.com/games/warfront"
        image="https://kyrosgames.com/images/warfront_background.jpg"
        imageAlt="WarFront key art"
      />

      <GameShowcasePage
        theme="warfront"
        eyebrow="WarFront"
        title="WarFront"
        summary="FPS tattico per Windows. Leggi la scheda, accedi con l'account Kyros e acquista dallo Store quando sei pronto."
        productCode="warfront"
        cover="/images/warfront_background.jpg"
        coverAlt="Cover di WarFront"
        highlights={[
          "Windows",
          "Store Kyros",
          "Licenza account"
        ]}
        primaryAction={{
          label: "Apri lo Store",
          to: "/store",
          icon: FaShoppingCart
        }}
        secondaryAction={{
          label: "Supporto e rimborsi",
          to: "/terms",
          icon: FaHeadset
        }}
        storyTitle="Leggi prima di acquistare"
        storyParagraphs={storyParagraphs}
        features={features}
        facts={facts}
        mediaCard={mediaCard}
      />
    </>
  );
}
